import { Link } from 'react-router-dom'
import mark from '../../assets/larice-mark.png'

export function BrandLogo({ compact = false }: { compact?: boolean }) {
  return (
    <Link
      to="/"
      className={`brand-logo ${compact ? 'brand-logo--compact' : ''}`}
      aria-label="LARICE H100 Observatory home"
    >
      <img src={mark} alt="" />
      <span>
        <strong>LARICE</strong>
        <small>{compact ? 'H100 Observatory' : 'H100 Observatory'}</small>
      </span>
    </Link>
  )
}
